<template>
    <div class="home-container">
        <!-- <div class="content-section"> -->
        <HomeHeader />
        <NewsSection />
        <TechSection />
        <ProductSection />
        <CustomerChoice />
        <PatentSection />
        <ConsultSection />
        <Footer />
        <!--<div class="Aichat">
            <ChatWidget :defaultOpen="isOpen" />
            <div class="Aitext" @click="openChat">AI小曼</div>
        </div>-->

        <!-- </div> -->
    </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue'
import NewsSection from '@/components/NewsSection.vue'
import TechSection from '@/components/TechSection.vue'
import ProductSection from '@/components/ProductSection.vue'
import CustomerChoice from '@/components/CustomerChoice.vue'
import PatentSection from '@/components/PatentSection.vue'
import ConsultSection from '@/components/ConsultSection.vue'
import Footer from '@/components/Footer.vue'
import ChatWidget from '@/components/ChatWidget.vue'


export default {
    name: 'Home',
    components: {
        HomeHeader,
        NewsSection,
        TechSection,
        ProductSection,
        CustomerChoice,
        PatentSection,
        ConsultSection,
        Footer,
        ChatWidget
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        openChat() {
            console.log(this.isOpen)
            this.isOpen = !this.isOpen
        }
    }
}
</script>

<style scoped>
.content-section {
    margin: 30px 0;
}

.Aichat {
    position: fixed;
    bottom: 0px;
    right: 50px;
    cursor: pointer;
    height: 80px;
    color: #000;
    width: 60px;
    background: #fff;
    border-radius: 10px;
}

.Aitext {
    position: absolute;
    bottom: 0px;

    right: 0px;
    width: 60px;
    background: #fff;
    /* height: 70px; */

    cursor: pointer;
    color: #29AB0B;
    text-align: center;
}
</style>